import "./style.css";
import { registerSW } from "virtual:pwa-register";

import { seedIfEmpty } from "./data/faults.seed";
import { startAutoSync } from "./core/sync";
import { countFaults } from "./storage/db";
import { mountUI, refreshBoards, refreshFaultCount, updateSyncBadge } from "./ui/app";

// Service worker (offline shell). autoUpdate : mise à jour silencieuse.
registerSW({ immediate: true });

async function boot(): Promise<void> {
  await seedIfEmpty();
  const root = document.getElementById("app");
  if (!root) return;
  await mountUI(root);
  updateSyncBadge("init");
  refreshFaultCount(await countFaults());

  // Sync en arrière-plan (no-op si core absent/hors-ligne) ; rafraîchit le badge
  // et le compteur de pannes après chaque cycle.
  startAutoSync(async (report) => {
    updateSyncBadge(report);
    refreshFaultCount(await countFaults());
    await refreshBoards(); // la KB board a pu arriver/changer pendant la sync
  });

  window.addEventListener("online", () => updateSyncBadge("init"));
  window.addEventListener("offline", () => updateSyncBadge("init"));
}

void boot();
